import { ModalContext } from "@lib/context/ModalContext";
import { ModalHandler } from "@lib/ModalHandler";
import { setApiKeyToStorage, validateApiKey } from "@lib/util/api";
import { startFillAgnostic } from "@lib/util/form_util_agnostic";
import { Accessor, useContext } from "solid-js";
import { FetchStatusMessage } from "./fetchStatusComponents/FetchStatusMessage";
import { LoadingSpinner } from "./fetchStatusComponents/LoadingSpinner";

export function ApiKeyForm(props: { modalHandler: Accessor<ModalHandler> }) {
  const {
    setIsApiKeyValid,
    isApiCheckLoading,
    apiCheckStatus,
    fetchApiCheck: fetchApiCheck,
  } = useContext(ModalContext)!;
  let apiInputRef: HTMLInputElement;

  async function handleApiKeySubmit(event: SubmitEvent) {
    event.preventDefault();
    props.modalHandler().clearAllStatus();

    const apiKey = apiInputRef!.value;
    if (!apiKey.trim()) {
      return;
    }

    await fetchApiCheck(() => validateApiKey(apiKey));
    if (apiCheckStatus().isSuccess) {
      setIsApiKeyValid(() => true);
      setApiKeyToStorage(apiKey);
      await startFillAgnostic(props.modalHandler);
    }
  }

  return (
    <form onSubmit={handleApiKeySubmit} method="get" class="my-1">
      <label class="d-block form-label text-white">Submit an API Key</label>
      <input ref={apiInputRef!} type="text" class="my-1 form-control bg-dark text-white border-light" />
      <button type="submit" class="my-2 btn btn-primary d-block w-100" disabled={isApiCheckLoading()}>
        Submit API Key
        {isApiCheckLoading() && <LoadingSpinner />}
      </button>
      {!isApiCheckLoading() && (apiCheckStatus().isError || apiCheckStatus().isSuccess) && (
        <FetchStatusMessage fetchStatus={apiCheckStatus} />
      )}
    </form>
  );
}
